import React, { useState } from 'react';
import { findValidUser } from '../services/AuthService'

const AuthContext = React.createContext({
  token: '',
  isLoggedIn: false,
  login: (token) => {},
  checkUser: () => {},
  status: 'invalid',
  userRole: ''
})

export const AuthContextProvider = (props) => {
  const [token, setToken] = useState(null)
  const [role, setRole] = useState(null)
  const [status, setStatus] = useState('invalid')

  const loginHandler = (token, role) => {
    setStatus('valid')
    if (token) {
      setToken(token)
      localStorage.setItem('token', token)
    }
    if (role) {
      setRole(role)
    }
  }

  const userCheckHandler = (userId, token) => {
    const validUser = findValidUser(userId)
    if (validUser) {
      setToken(token)
      localStorage.setItem('token', token)
      return {
        user: 'verkosto'
      }
    }
    return false
  }

  const userIsLoggedIn = !!token
  const authCheckStatus = status
  const userRole = role

  const contextValue = {
    token: token,
    isLoggedIn: userIsLoggedIn,
    login: loginHandler,
    checkUser: userCheckHandler,
    authCheckStatus: authCheckStatus,
    userRole: userRole
  }
  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  )
}

export default AuthContext
